import axios from 'src/utils/axios';
import helpers from 'src/helpers';
import { NOTIFICATION_STATUS } from 'src/constants';
import { addNotification } from 'src/actions/notificationActions';

export const GET_SCHEDULED_MESSAGE = '@scheduled-messages-details/get-scheduled-message';
export const GET_SCHEDULED_MESSAGE_SUCCESS = '@scheduled-messages-details/get-scheduled-message-success';
export const GET_SCHEDULED_MESSAGE_ERROR = '@scheduled-messages-details/get-scheduled-message-error';

export const UPDATE_SCHEDULED_MESSAGE = '@scheduled-messages-details/update-scheduled-message';
export const UPDATE_SCHEDULED_MESSAGE_SUCCESS = '@scheduled-messages-details/update-scheduled-message-success';
export const UPDATE_SCHEDULED_MESSAGE_ERROR = '@scheduled-messages-details/update-scheduled-message-error';

export const SOCKET_SCHEDULED_MESSAGE_MANUALLY_SENT = '@scheduled-messages-details/socket-scheduled-message-manually-sent';

export const SOCKET_SCHEDULED_BIRTHDAY_MESSAGE_SENT = '@scheduled-messages-details/socket-scheduled-birthday-message-sent';

export const getScheduledMessage = (messageId) => async (dispatch) => {
  dispatch({
    type: GET_SCHEDULED_MESSAGE,
  });
  try {
    const response = await axios.get(`/api/scheduledMessages/${messageId}`);
    dispatch({
      type: GET_SCHEDULED_MESSAGE_SUCCESS,
      payload: response?.data || {}
    });
  } catch (e) {
    const {
      error,
      message,
    } = e?.response?.data || {};
    dispatch(addNotification(GET_SCHEDULED_MESSAGE_ERROR, helpers.transform.toString(message || error || 'Server error'), NOTIFICATION_STATUS.ERROR));
    dispatch({
      type: GET_SCHEDULED_MESSAGE_ERROR,
    });
  }
};

export const updateScheduledMessage = (scheduledMessage, doWhenTry, doWhenCatch) => async (dispatch) => {
  dispatch({
    type: UPDATE_SCHEDULED_MESSAGE,
  });
  try {
    const {
      messageId,
      message,
      attachment,
      attachmentContainer,
      scheduledDateTime,
      sendMessageEnabled = true,
      attachments,
    } = scheduledMessage || {};
    const response = await axios.put(
      `/api/scheduledMessages/${messageId}`,
      {
        body: message,
        attachment,
        // CON-1929 — only the multi-attachment beta form sends the list;
        // every other caller sends `attachment` alone, as before.
        ...(Array.isArray(attachments) ? { attachments } : {}),
        messageAttachmentContainer: attachmentContainer,
        scheduledDateTime,
        sendMessageEnabled,
      }
    );
    dispatch({
      type: UPDATE_SCHEDULED_MESSAGE_SUCCESS,
      payload: response?.data || {}
    });
    if (doWhenTry) {
      doWhenTry();
    }
  } catch (e) {
    const {
      error,
      message,
    } = e?.response?.data || {};
    dispatch(addNotification(UPDATE_SCHEDULED_MESSAGE_ERROR, helpers.transform.toString(message || error || 'Server error'), NOTIFICATION_STATUS.ERROR));
    dispatch({
      type: UPDATE_SCHEDULED_MESSAGE_ERROR,
    });
    if (doWhenCatch) {
      doWhenCatch(e);
    }
  }
};

export const socketScheduledMessageManuallySent = (message) => async (dispatch) => {
  dispatch({
    type: SOCKET_SCHEDULED_MESSAGE_MANUALLY_SENT,
    payload: message,
  });
};

export const socketScheduledBirthdayMessageSent = (message) => async (dispatch) => {
  dispatch({
    type: SOCKET_SCHEDULED_BIRTHDAY_MESSAGE_SENT,
    payload: message,
  });
};
